module.exports = __webpack_public_path__ + "img/Spotify_logo.cc4e2784.png";